import { Installation } from '@/features/suppliers/hooks/installations'
import SupplierEmissionsReportGoodsDataForm from './SupplierEmissionsReportGoodsDataForm'
import { SupplierEmissionsReportEmissionsDataForm } from './SupplierEmissionsReportEmissionsDataForm'
import { SupplierEmissionsReportEvidenceForm } from './SupplierEmissionsReportEvidence'
import { SupplierEmissionsReport } from '@/features/suppliers/hooks/supplierEmissionsReport'
import { SupplierEmissionsReportFormData } from './SupplierEmissionsReportForm.schema'

type SupplierEmissionsReportFormProps = {
  data: SupplierEmissionsReportFormData
  onChange: (data: SupplierEmissionsReportFormData) => void
  isEditMode?: boolean
  originalPeriodId?: string
  goodsDataLocked?: boolean
  installation: Installation
  supplierEmissionsReports: SupplierEmissionsReport[]
}

export default function SupplierEmissionsReportForm({
  data,
  onChange,
  installation,
  supplierEmissionsReports,
  isEditMode = false,
  originalPeriodId,
  goodsDataLocked = false
}: SupplierEmissionsReportFormProps) {
  const { startMonth, monthInterval, goodsFamily, basisForReportingPeriod, country } = installation
  return (
    <div className="space-y-6 pb-2">
      <SupplierEmissionsReportGoodsDataForm
        data={data}
        onChange={onChange}
        goodsFamily={goodsFamily}
        startMonth={startMonth}
        monthInterval={monthInterval}
        basisForReportingPeriod={basisForReportingPeriod}
        isEditMode={isEditMode}
        originalPeriodId={originalPeriodId}
        goodsDataLocked={goodsDataLocked}
      />
      <SupplierEmissionsReportEmissionsDataForm
        data={data}
        onChange={onChange}
        supplierCountry={country}
      />
      <SupplierEmissionsReportEvidenceForm
        data={data}
        onChange={onChange}
        supplierEmissionsReports={supplierEmissionsReports}
      />
    </div>
  )
}
